import React from "react";
import { t } from "ttag";

import { useAppDispatch } from "../../reducers";
import { Actions } from "../actions";
import { FormView } from "./abstract/FormView";

interface IProps {
    basketID: number;
    email: string;
}

export const BasketAssign = (props: IProps) => {
    const dispatch = useAppDispatch();
    const actions = new Actions(dispatch);

    return (
        <FormView
            submitLabel={t`Assign Basket`}
            actions={actions}
            fields={[
                {
                    label: t`Email Address`,
                    name: "email",
                    type: "email",
                },
            ]}
            initialValues={props}
            onSubmit={async (event, data) => {
                event.preventDefault();
                const email = data.email as string;
                await actions.assignBasket(props.basketID, email);
                await Promise.all([
                    actions.loadCurrentlyAssistedCustomer(),
                    actions.loadCurrentlyAssistedBasket(),
                ]);
                actions.popViewStack();
            }}
        />
    );
};
